// extracted by mini-css-extract-plugin
export default {"BaseCell":"dropdown-cell-module__BaseCell__KZn6XIl"};